import React from 'react';
import classes from './MemberInfo.css';
import Label from '../../UI/Label2/Label2';

const memberInfo = (props) => (
    <React.Fragment>
    <div className={classes.MemberInfo}>
        <Label displayType="horizontal" labelText="Username:" labelValue={props.memberInfo.essoData.userName} labelAlign="right" />
        <Label displayType="horizontal" labelText="First Name:" labelValue={props.memberInfo.mdmFirstNm} labelAlign="right" />
        <Label displayType="horizontal" labelText="Last Name:" labelValue={props.memberInfo.mdmLastNm} labelAlign="right" />
        <Label displayType="horizontal" labelText="DOB:" labelValue={props.memberInfo.mdmDob} labelAlign="right" />
        <Label displayType="horizontal" labelText="Zip:" labelValue={props.memberInfo.mdmZip} labelAlign="right" />
    </div>
    </React.Fragment>
);

export default memberInfo;